import React from 'react';

import PillarOverviewSlider from '../../PillarOverviewSlider';

import './style.scss';

const DownloadsPillarOverview = ({ entities, entity, ...props }) => {
  const url = `${window.location.pathname}/downloads`;

  return (
    <PillarOverviewSlider
      className="DownloadsPillarOverview"
      url={url}
      subTitle="Bekijk alle downloads"
      title={entity.getIn(['field_label', 0, 'value'])}
      body={entity.getIn(['field_text', 0, 'processed'])}
      entities={entities}
      {...props}
    />
  );
};

export default DownloadsPillarOverview;
